var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[(!_vm.hideIfNoValue || _vm.value)?_c('span',[_vm._v(" "+_vm._s(_vm.shortPrice)+" ")]):_vm._e()])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltipValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }